//import commands from '../../lib/haas-sl-fanuc-2006.js';
import { useState, useRef } from 'react';
import Form from '../JsonForm/Form';

const FormPage = () => {
    const [commands, setCommands] = useState(localStorage.getItem('commands') ? JSON.parse(localStorage.getItem('commands')) : null);
    const [error, setError] = useState('');
    const fileField = useRef(null);

    const handleUpload = () => {
        fileField.current.click();
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setError('');

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const parsed = JSON.parse(event.target.result);

                // Optional: Validate the JSON structure using a custom function
                if (validateLatheJSON && !validateLatheJSON(parsed)) {
                    throw new Error('JSON structure is invalid.');
                }

                setCommands(parsed);
                localStorage.setItem('commands', event.target.result);
                setError('');
            } catch (err) {
                setError('Invalid JSON file: ' + err.message);
                setCommands(null);
            }
        };

        reader.readAsText(file);
    };

    function validateLatheJSON(data) {
        if (typeof data !== 'object' || data === null) return false;
    
        // Validate top-level keys
        const requiredTopKeys = [
            'author', 'version', 'type', 'manufacturer',
            'model', 'controller', 'years-made', 'commands', 'moveCommands'
        ];
    
        for (const key of requiredTopKeys) {
            if (!(key in data)) return false;
        }
    
        // Validate moveCommands
        if (!Array.isArray(data.moveCommands) || !data.moveCommands.every(cmd => typeof cmd === 'string')) {
            return false;
        }
    
        // Validate commands
        if (typeof data.commands !== 'object' || data.commands === null) return false;
    
        for (const [, commandGroup] of Object.entries(data.commands)) {
            if (typeof commandGroup !== 'object' || commandGroup === null) return false;
    
            for (const [subKey, command] of Object.entries(commandGroup)) {
                if (subKey === 'main') {
                    if (typeof command !== 'string') return false;
                    continue;
                }
    
                if (typeof command !== 'object' || command === null) return false;
    
                if (('value' in command) && typeof command.value !== 'string') return false;
    
                if ('sublevels' in command) {
                    if (typeof command.sublevels !== 'object' || command.sublevels === null) return false;
                }
            }
        }
    
        return true;
    }

    const finish = () => {
        localStorage.clear();
        setCommands(null);
    }

    return (
        <>
            {commands ? <Form commands={commands} finish={finish} /> : 
            <div className="start-form">
                <div className="upload-file">
                    <input type="file" accept=".json" ref={fileField} onChange={handleFileUpload} />
                    <button type="button" onClick={handleUpload}>Upload existing machine</button>
                    {error && <p className="error">{error}</p>}
                </div>
                <button type="button" onClick={() => setCommands({commands: [], moveCommands: []})}>New machine</button>
            </div>}
        </>
    );
};

export default FormPage;